module.exports = __webpack_public_path__ + "static/img/third1_8_active.25b0eaf1.jpg";